
























































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Mutation, State } from 'vuex-class'
import FileUpload from '../StepsFive/FileUpload.vue'

@Component({
  components: { FileUpload },
})
export default class BusinessOthers extends Vue {
  @Prop({ required: true, type: Object }) form!: any
  @State bidType!: number
  @State coopChannel!: number
  @Mutation setChannel!: Function
  channelType = {
    '1': '小芒平台',
    '2': 'MT星球',
  }
  get rules() {
    return {
      company_region: [
        { required: true, message: `请选择${this.bidTypeText}实际办公地址` },
      ],
      company_address: [{ required: true, message: '请填写办公详细地址' }],
      industry: [
        { required: true, message: `请填写${this.bidTypeText}所属行业` },
      ],
      company_email: [
        { required: true, message: `请填写${this.bidTypeText}邮箱` },
        { type: 'email', message: '邮箱格式不正确' },
      ],
      ...(this.bidType === 2 && this.coopChannel === 2
        ? {}
        : {
            company_tel_area: [
              { required: true, validator: this.validateTel.bind(this) },
            ],
            company_type: [{ required: true, message: '请选择公司类型' }],
          }),
      pop_contract_url: [{ required: true, message: '请上传合同协议' }],
      expire_date: [{ required: true, message: '请选择合作截止时间' }],
    }
  }

  perRules = {
    coop_channel: [{ required: true, message: '请选择合作渠道' }],
  }
  companyType = {
    '1': '品牌商',
    '2': '经销商',
    '3': '代理商',
  }

  get antForm() {
    return this.$refs.form
  }

  get bidTypeText() {
    return this.bidType === 8 ? '' : '公司'
  }

  changeChannel(value: any) {
    this.setChannel(value)
  }

  validateTel(rule: any, value: string, callback: any) {
    const { company_tel } = this.form
    if (!value) {
      callback(new Error('请填写区号'))
      return
    }
    if (!company_tel) {
      callback(new Error('请填写座机号'))
      return
    }
    callback()
  }

  onDeletePopContract() {
    this.form.pop_contract_url = ''
  }

  onPopContractChange({ file }: any) {
    if (file.status === 'done') {
      this.$set(this.form, 'pop_contract_url', file.url)
    }
  }
}
